export const SLICING_QUERY_KEY = "slicing";
export const slicesQueryKeyForColumn = (sliceCol) => [SLICING_QUERY_KEY, sliceCol];
export const slicesQueryKey = (sliceCol, query, filters, entityTableId, layoutVariant) => [...slicesQueryKeyForColumn(sliceCol), query, filters, entityTableId, layoutVariant];
